var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var SolderMaskInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    ShapeWrapperInteractionView.apply(this, arguments);
};
lib_core.inherit(SolderMaskInteractionView,  ShapeWrapperInteractionView);

module.exports = SolderMaskInteractionView;

SolderMaskInteractionView.prototype.getLayers = function () {
    //It is very ugly that the visible layers in footprint and visible layers in pcb editor have different values.
    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP) || this.editorModel.visibleLayers.contains(0))) {
        console.assert(this.layers.soldermaskTop && this.layers.soldermaskTopControl, "Missing layers");

        return {
            draw: this.layers.soldermaskTop,
            control: this.layers.soldermaskTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM) || this.editorModel.visibleLayers.contains(1))) {
        console.assert(this.layers.soldermaskBottom && this.layers.soldermaskBottomControl, "Missing layers");

        return {
            draw: this.layers.soldermaskBottom,
            control: this.layers.soldermaskBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
}